module.exports = __webpack_public_path__ + "img/eval-icon-name.bfa64858.svg";